import React, { useEffect, useRef, useState } from 'react';
import { brandLogos } from '../../data/mock';

const BrandAuthority = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative py-16 bg-[#0A0A0A] border-y border-[#D4AF37]/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Label */}
        <p
          className={`text-center text-[#A1A1AA] text-xs tracking-[0.3em] mb-12 transition-all duration-1000 ease-out ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          TRUSTED BY INDUSTRY LEADERS
        </p>

        {/* Brand Logos */}
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-16">
          {brandLogos.map((brand, index) => (
            <div
              key={brand.name}
              className={`transition-all duration-700 ease-out ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <span className="text-white/40 text-xl md:text-2xl tracking-[0.3em] font-light hover:text-[#D4AF37] transition-colors duration-500 cursor-default">
                {brand.displayed}
              </span>
            </div>
          ))}
        </div>

        {/* Decorative Line */}
        <div
          className={`mt-12 h-[1px] bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent transition-all duration-1000 ease-out ${
            isVisible ? 'opacity-100 scale-x-100' : 'opacity-0 scale-x-0'
          }`}
          style={{ transitionDelay: '600ms' }}
        />
      </div>
    </section>
  );
};

export default BrandAuthority;
